<template>
  <div id="cardSetUp">
    <div class="packagePanel">
      <h1 class="package-title-ka">
        <p>激活卡号：{{ recordLoginText }}</p>
      </h1>
      <h1 class="package-title">选择套餐</h1>
      <div class="u-flex">
        <template v-for="item in soldPackage">
          <div class="package" :key="item.id" :class="{ 'label-defined-active': indexActive == item.id }"
            @click="changeState1(item)">
            <div class="package-name" :class="{ 'overlay-package': item.type == 11 || item.type == 16 }">
              <h1 style="color: #07c160;" v-if="item.type == 11 || item.type == 16 || item.type == 18">
                {{ item.packageName ? item.packageName : item.name }}</h1>
              <h1 v-else>{{ item.packageName ? item.packageName : item.name }}</h1>
              <span style="color:#ACACAC;font-size:12px;"> {{ item.remark }}</span>
            </div>
            <div class="package-price" :class="{ 'overlay-package': item.type == 18 }">
              <p>{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}<span>元</span></p>
              <div class="yjy">原价{{ (item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100) + 10 }}元</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="cardSetUp-middle">
      <h1 class="cardSetUp-middle-title">请选择开卡预存费用</h1>
      <div class="package-choose">
        <div class="package-choose-item" v-for="(item, index) in packageChoose" :key="index"
          :class="{ 'package-item-action': currentItem == index }" @click="changeState(index, item[0], item[1])">
          <div class="package-choose-item-price">{{ item[0] }}<span>元</span></div>
          <div class="packahe-choose-item-desc" :class="{ 'package-item-action-desc': currentItem == index }">到账{{ item[1]
          }}元</div>
        </div>
      </div>
    </div>
    <div class="toRecharge-top" v-if="showMonthChoose">
      <van-radio-group v-model="isNextMonth" class="radio-group-defined">
        <div>
          <van-radio name="0" checked-color="#FFA941">本月生效</van-radio>
        </div>
        <div>
          <van-radio name="1" checked-color="#FFA941">次月生效</van-radio>
        </div>
      </van-radio-group>
    </div>
    <div class="cardSetUp-action-btn">

      <button @click="toCheckStand()">立 即 购 买</button>
    </div>
    <!-- <div class="cardSetUp-tip1" v-show="!isWx">
      <p style="color:red"><span></span>开户完成后 请点击实名激活进行认证后，方可使用。</p>
    </div>
    <div class="cardSetUp-action-btn" v-show="!isWx">
      <button @click="btnActionRecharge1()">实名激活</button>
    </div> -->
    <div class="cardSetUp-tip">
      <p><span>注：</span>开卡前请选择好您需要购买的套餐，缴费成功后马上到账，预存费用减去您选择的套餐费用的剩余的金额，后续可用于您再次购买套餐使用。</p>
    </div>
    <!-- 修改密码框   -->
    <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
    <div class="van-popup van-popup--round van-popup--center changePasswordPanel-cardSetUp"
      style="z-index: 2000; min-height: 25%; min-width: 80%;" v-show="showPasswordPanel"
      :style="{ top: passwordPanelTop + '%' }">
      <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()" />
      <!-- 密码输入框 -->
      <p>设置开户支付密码：</p>
      <van-password-input :value="password" :focused="passwordKeyboard" @focus="passwordOnfocus()" />

      <!-- 再次确认密码输入框 -->
      <p>再次确认开户密码：</p>
      <van-password-input :value="confirmPassword" :focused="confirmPasswordKeyboard" @focus="confirmPasswordOnfocus()" />
      <div class="confirmChangePassword">
        <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">确 定
        </van-button>
      </div>

    </div>

    <!-- 数字键盘 -->
    <van-number-keyboard :z-index="2015" :show="passwordKeyboard" @input="passwordOnInput" @delete="passwordOnDelete"
      @blur="passwordKeyboard = false" />

    <van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard" @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete" @blur="confirmPasswordKeyboard = false" />
    <!-- 数字键盘 end -->
    <!-- 修改密码框 end  -->



    <div v-html="payUrl"></div>
    <div class="shareit" v-if="is_WeChat">
      <img class="arrow" src="@/assets/img/arrowhead.png" />
      <div class="follow">支付宝支付请使用游览器进行支付,<br />请在菜单中选择游览器打开<br />如已完成支付，退出重新登录查询即可</div>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';

import { wxRequest } from '@/api/user.js'
import Checkstand from "@/components/Checkstand";

export default {
  data() {
    return {
      is_WeChat: false,
      payUrl: '',
      isWx: false,
      showMonthChoose: true,
      recordLoginText: localStorage.getItem('recordLoginText'),
      payCode: localStorage.getItem("payCode"),
      flowPkg: 0,
      isNextMonth: '0',
      flowPkgArray: [],

      payData: '',
      //原始流量套餐包
      soldPackage: [],
      isAdmin: '0',
      iccid: '',
      packageChoose: [],
      //设置密码
      password: '',
      confirmPassword: "000000",
      alreadySetUp: false,
      showPasswordPanel: false,
      passwordKeyboard: false,
      confirmPasswordKeyboard: false,
      passwordPanelTop: 50,


      //当前余额套餐
      currentItem: 0,
      price: 0,
      giftBalance: 0,

      //自定义金额
      popup: false,

      //自定义键盘
      showKeyboard: false,
      leshuaPay: localStorage.getItem('leshuaPay'),
      definedPrice: '',

      type: '',
      indexActive: '',

      //收银台
      dataToPay: {},
      checkstandStyle: {
        height: '50%',
        transition: '0.8s !important',
      },

    }
  },
  methods: {

    closePopup() {
      this.popup = false;
    },
    changeState1(item) {
      this.indexActive = item.id;
    },

    changeState(currentItem, price, giftBalance) {
      this.currentItem = currentItem;
      this.price = price;
      this.giftBalance = (giftBalance - price) * 100;
    },

    //点击【自定义】时
    showPackageItemDefined(currentItem) {
      this.popup = true;
      this.currentItem = currentItem;
      this.price = null;
      this.giftBalance = 0;
    },

    //唤起收银台
    toCheckStand() {
      if (this.indexActive == '') {
        Dialog.alert({ message: "请选择购买套餐" });
        return false;
      }
      // 
      var payType = 20;
      if (this.leshuaPay == 1 || this.leshuaPay == '1') {
        payType = 50;
      } else if (this.payCode == 502) {
        payType = 60;
      } else if (this.payCode == 503) {
        payType = 80;
      } else if (this.payCode == 532) {
        payType = 32;
      }
      var data = {
        iccid: this.$store.state.iccid,
        //iccid:'8888888888888888889',
        amount: this.price * 100,
        giftBalance: this.giftBalance,
        payPass: this.confirmPassword,
        isAdmin: this.isAdmin,
        soldPackageId: this.indexActive,
        isNextMonth: this.isNextMonth,
        payType: payType,
        mobile: '',
        pkgId: this.indexActive,
        payPrice: 'pay_amonts'
      }

      wxRequest("sim/activity/timer", data, "post").then(res => {
        var result = res.data.data;
        var date = new Date();
        var day = date.getDate();
        if (res.data.code == 200) {
          Dialog.confirm({
            title: "套餐生效提醒",
            message: "生效时间：" + res.data.data.start + "<br/>到期时间：" + res.data.data.end +
              "<br/>" +
              "<font style='color:red;font-weight:bold;'>余额账户默认密码：000000</font>"
          }).then(() => {


            wxRequest("order/user/create/investOrder", data, "post").then(res => {
              if (res.data.code == 200) {
                if (data.payType == 50) {//乐刷
                  window.location.href = res.data.data.jspay_url;
                } else if (data.payType == 20) {//微信第三方
                  if (this.isWx) {
                    var param = res.data.data.param;
                    if (typeof WeixinJSBridge == "undefined") {
                      if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                      } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                      }
                    } else {
                      this.onBridgeReady(param);
                    }
                  } else {
                    window.location.href = res.data.data.mweb_url;
                  }
                } else if (data.payType == 32) {//微信第三方
                  var param = res.data.data;
                  if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                      document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                    } else if (document.attachEvent) {
                      document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                      document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                    }
                  } else {
                    this.onBridgeReady(param);
                  }
                } else if (data.payType == 60) {//汇付天下
                  let datas = JSON.parse(res.data.data);
                  if (datas.status === 'succeeded') {
                    let payment = datas;
                    AdaPay.doPay(payment, (res) => {
                      Dialog.alert({ title: '提示', message: res.result_message });
                      this.cancelPay();
                    })
                  }
                } else if (data.payType == 80) {
                  window.location.href = res.data.data;
                  // var ua = window.navigator.userAgent.toLowerCase();
                  // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                  //   //进入引导页
                  //   this.is_WeChat = true
                  //   var timer = setInterval(() => {
                  //     clearInterval(timer)
                  //     this.$router.push({ path: '/user/openPrice', query: { row: encodeURIComponent(JSON.stringify(res.data.data)) } });
                  //   }, 1000)
                  // } else {
                  //   this.payUrl = res.data.data
                  //   this.$nextTick(() => {
                  //     document.forms[0].submit()
                  //   })
                  // }
                }
              } else {
                Dialog.alert({ message: res.data.message });
              }
            })

          }).catch(() => {
          });

        } else {

          let formData = new FormData();
          Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
          });

          wxRequest("order/user/create/investOrder", data, "post").then(res => {
            if (res.data.code == 200) {
              if (data.payType == 50) {//乐刷
                window.location.href = res.data.data.jspay_url;
              } else if (data.payType == 20) {//微信第三方
                if (this.isWx) {
                  var param = res.data.data.param;
                  if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                      document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                    } else if (document.attachEvent) {
                      document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                      document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                    }
                  } else {
                    this.onBridgeReady(param);
                  }
                } else {
                  window.location.href = res.data.data.mweb_url;
                }
              } else if (type == 60) {//汇付天下
                let datas = JSON.parse(res.data.data);
                if (datas.status === 'succeeded') {
                  let payment = datas;
                  AdaPay.doPay(payment, (res) => {
                    Dialog.alert({ title: '提示', message: res.result_message });
                    this.cancelPay();
                  })
                }
              } else if (data.payType == 32) {//微信第三方
                var param = res.data.data;
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                  } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                  }
                } else {
                  this.onBridgeReady(param);
                }
              }


            } else {
              Dialog.alert({ message: res.data.message });
            }
          })
        }
      })


    },

    //输入完密码后点击 【确定】 时
    sureToRecharge() {
      if (this.checkPassword()) {
        if (this.type == "recharge") {
          this.toCheckStand();
        } else if (this.type == "rechargeDefined") {
          this.toRechargeDefined();
        }
      }
    },
    //流量套餐充值时唤起微信支付
    onBridgeReady(param) {
      let _this = this;
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', param,
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
              _this.$router
                .push({
                  path: "/user/homeNew",
                  query: {
                    iccid: _this.$store.state.iccid,
                  },
                })
                .catch(() => { });
            } else if (_this.$store.state.isNewPage == 2 || localStorage.getItem('isNewPage') == 2) {
              _this.$router
                .push({
                  path: "/user/homeTwo",
                  query: {
                    iccid: _this.$store.state.iccid,
                  },
                })
                .catch(() => { });
            } else {
              _this.$router
                .push({
                  path: "/user/home",
                  query: {
                    iccid: _this.$store.state.iccid,
                  },
                })
                .catch(() => { });
            }
          }
        }
      );
    },
    btnActionRecharge() {
      if (this.indexActive == '') {
        Dialog.alert({ message: "请选择购买套餐" });
        return false;
      }
      this.type = "recharge";
      //若当前为自定义状态
      if (this.currentItem == 999) {
        this.popup = true;
      } else {
        this.showPasswordPanel = true;
      }

    },
    btnActionRecharge1() {
      let data = {
        iccid: this.$store.state.iccid
      }
      wxRequest("sim/is/have/pkg", data, "get").then(res => {
        if (res.data.code == 200) {
          let types = res.data.data;
          if (types == 49) { //联通
            this.$router.push({
              path: '/user/cuccAuth',
              query: {
                realNameCard: 1
              }
            })
          } else if (types == 3) { //移动
            this.$router.push({
              path: '/user/cmccAuths',
              query: {
                realNameCard: 1
              }
            })
          } else {
            this.$router.push({
              path: '/user/ctccAuth',
              query: {
                realNameCard: 1
              }
            })
          }

        } else {
          Dialog.alert({ message: "请先选择开户，再进行实名激活" });
        }
      });


    },
    btnActionRechargeDefined() {
      this.type = "rechargeDefined";

      if (this.definedPrice < 1) {
        Dialog.alert({ message: "金额过低" });
        return false;
      }
      this.showPasswordPanel = true;
    },

    toRechargeDefined() {
      let data = {
        iccid: this.$store.state.iccid,
        amount: this.definedPrice * 100,
        giftBalance: this.giftBalance,
        payPass: this.confirmPassword,
        isAdmin: this.isAdmin,
      }

      for (let i = this.soldPackage.length - 1; i >= 0; i--) {
        if (this.soldPackage[i].id == this.flowPkg) {
          data.soldPackageId = this.flowPkg;
          data.isNextMonth = '0';
        }
      }

      this.$store.state.showCheckstandSource = 'balanceRecharge';
      this.dataToPay = data;
      this.$store.state.showCheckstand = true;
      this.price = this.definedPrice;
      this.definedPrice = '';
      this.closePopup();

      this.cancelChangePassword();

    },


    /***   修改密码     ***/
    passwordOnfocus() {
      this.passwordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    passwordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1);
    },

    passwordOnInput(key) {
      this.password = (this.password + key).slice(0, 6);
    },


    confirmPasswordOnfocus() {
      this.passwordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },


    cancelChangePassword() {
      this.password = '';
      this.confirmPassword = '';
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },

    checkPassword() {
      if (this.password.length < 6) {
        Dialog.alert({ message: "请设置六位支付密码" });
        return false;
      }

      if (this.password != this.confirmPassword) {
        Dialog.alert({ message: "两次输入的新密码不一致" });
        return false;
      }
      return true;
    },


    /***   修改密码  end   ***/


  },
  created() {
    this.iccid = this.$store.state.iccid ?
      this.$store.state.iccid :
      localStorage.getItem('iccid');
    // this.iccid='8888888888888888889'

    this.isWx = true;

    this.is_WeChat = false
    if (this.$route.query.row) {
      this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row))
      this.$nextTick(() => {
        document.forms[0].submit()
      })
    }
    wxRequest("sim/user/soldPkg/my", { iccid: this.iccid }, "get").then(res => {
      var result = res.data.data;
      if (res.data.code == 200 && result.list.length > 0) {
        this.soldPackage = result.list;
        if (result.list.length > 0) {
          this.indexActive = result.list[0].id
        }
        this.soldPackage.sort((a, b) => a.flowRate - b.flowRate);
        // todo 4条展示
        // this.soldPackage.push(result.list[0])
        this.isAdmin = result.isAdmin;
        //  流量套餐赋值
        for (let i = 0; i < result.list.length; i++) {
          this.flowPkgArray.push({
            text: result.list[i].packageName +
              " （ " + result.list[i].salePriceRmb + "元 ）  ",
            value: result.list[i].id
          });
        }
        this.showMonthChoose = this.soldPackage[0].type == 2 || this.soldPackage[0].type == 10 || this.soldPackage[0].type == 25 || this.soldPackage[0].type == 14 || this.soldPackage[0].type == 6 || this.soldPackage[0].type == 17 ? true : false;
        this.flowPkg = this.flowPkgArray[0].value;
        console.log(this.flowPkgArray)
      }
    })

    wxRequest("sim/uniorder/param", { iccid: this.iccid }, "post").then(res => {
      if (res.data.code == 200) {
        for (let i = 0; i < res.data.data.length; i++) {
          let itme = [res.data.data[i].amount, res.data.data[i].amount + res.data.data[i].giftBalance];
          this.packageChoose.push(itme);
        }

        this.price = this.packageChoose[0][0];
        this.giftBalance = (this.packageChoose[0][1] - this.packageChoose[0][0]) * 100;
      } else {
        Toast.fail(res.data.message);
      }
    })


  },

  mounted() {

  },

  beforeDestory() {

  }
}
</script>
<style>
#cardSetUp .flowPkg-choose {
  height: 36px;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__item {
  padding: 0 10px;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title {
  display: contents;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title .van-ellipsis {
  width: 100%;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title::after {
  right: 10px;
}

#cardSetUp .flowPkg-choose .van-dropdown-item__content {
  padding: 0 20px;
}

#cardSetUp .flowPkg-choose .van-dropdown-item__content .van-cell {
  padding-left: 8px;
  padding-right: 8px;
}

#cardSetUp .checkstand-defined-popup .van-field__control {
  font-size: 24px;
}

#cardSetUp .checkstand-defined-popup input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-moz-placeholder {
  /* Firefox 19+ */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-ms-input-placeholder {
  /* IE 10+ */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-moz-placeholder {
  /* Firefox 18- */
  font-size: 14px;
}

.changePasswordPanel-cardSetUp [class*=van-hairline]::after {
  border-color: #c4cedc;
}
</style>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#cardSetUp {
  background: #F4F3F3;

  .cardSetUp-top {
    min-height: 180px;
    padding: 30px 20px 10px 20px;
    margin-bottom: 20px;
    background: #fff;

    p {
      margin-bottom: 10px;
      padding-left: 10px;
      line-height: 36px;
      font-size: 16px;
    }

    h1 {
      margin-bottom: 10px;
      padding-left: 10px;
      font-weight: bold;
    }

    .flowPkg-choose {
      background: #F4F3F3;
    }

  }

  .packagePanel {
    padding-top: 5px;
    border-bottom: 10px solid #f5f5f5;

    .package-title-ka {
      width: 100;
      height: 46px;
      margin: 0 15px;
      background: url("../../assets/img/topback.png") no-repeat;
      background-size: 100% 100%;
      padding: 0 12px;
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;
      display: flex;
      align-items: center;
    }

    .package-title {
      color: #333;
      font-size: 18px;
      margin: 0 15px;
      margin-top: 24px;
      margin-bottom: 16px;
      font-weight: bold;
    }

    .u-flex {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      background: #fff;
      padding: 15px;

      .package {
        border: 1px solid #E5E5E5;
        border-radius: 6px;
      }

      .label-defined-active {
        border: 1px solid #FF6D00;
        background: #FFF6EF;
      }
    }

    .p-se {
      background: #E1EDFF;
    }

    .p-se2 {
      background: #E2F6FF;
    }

    .p-se3 {
      background: #FEECE0;
    }

    .package {
      width: 100%;
      display: flex;
      position: relative;
      margin-bottom: 10px;
      border-radius: 5px;



      .package-name {
        flex-grow: 1;
        padding: 12px 0 12px 43px;
        background: url('../../assets/432112.png') no-repeat 15px 16px;

        h1 {
          margin: 5px 0;
          color: #333333;
          font-weight: bold;
          font-size: 18px;
        }

        p {
          margin: 10px 0;
          font-weight: 500;
          color: #888888;
          width: 217px;
          line-height: 17px;
          font-size: 12px;
        }
      }

      .package-name.overlay-package {
        border-color: #07c160;
      }

      .package-price {
        width: 80px;
        // border: 1px solid #FFA941;
        // margin-right: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%);
        background: url('../../assets/31213.png') no-repeat right top;

        p {
          margin: 5px 0;
          font-size: 18px;
          font-weight: 500;
          color: #FF7600;
          text-align: left;
          width: 100%;
        }

        p:last-child {
          font-size: 28px;
          font-family: DINSchrift;

          span {
            font-size: 12px;
            color: #333333;
          }
        }

        .yjy {
          color: #ACACAC;
          font-size: 12px;
          text-align: left;
          width: 100%;
          text-decoration: line-through;
        }

      }

      .package-price.overlay-package {
        border-color: #07c160;
        background: #07c160;
      }

    }

    .label-defined {
      display: block;
      border-width: 14px 18px 14px 18px;
      border-style: solid;
      border-color: transparent;
      position: absolute;

      label {
        position: absolute;
        left: -14px;
        top: -12px;
        background: transparent;
      }
    }


    .package4 {
      width: 169px;
      height: 147px;
      background: #E1EDFF;
      border-radius: 4px;
      margin-bottom: 8px;

      .package4-name {
        flex-grow: 1;
        padding: 13px 13px 0;

        h1 {
          margin: 5px 0;
          color: #0D7FC6;
          font-weight: bold;
          font-size: 18px;
        }

        p {
          margin: 10px 0;
          font-weight: 500;
          color: #888888;
          line-height: 17px;
          font-size: 12px;
        }
      }

      .package4-price {
        display: flex;
        margin-left: 11px;
        align-items: center;
        width: 110px;
        height: 28px;
        background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%);
        border-radius: 14px;
        justify-content: center;

        p {
          font-size: 13px;
          font-weight: bold;
          color: #FEFEFE;
        }

        p:last-child {
          font-size: 20px;

          span {
            font-size: 13px;
          }
        }
      }
    }
  }


  .toRecharge {
    position: fixed;
    width: 100%;
    bottom: 0;
    font-size: 16px;

    .toRecharge-top {
      background: #F5F5F5;
      display: flex;

      .radio-group-defined {
        display: flex;
        padding-left: 20px;
        justify-content: center;
        align-items: center;
        height: 40px;

        div {
          height: 20px;
          margin-right: 15px;
        }
      }

    }

    .detail {
      color: #a0a0a0;
      background: #F5F5F5;
      padding-left: 20px;
      padding-bottom: 5px;
    }

    .toRecharge-bottom {
      display: flex;

      p {
        padding-right: 15px;
        flex-grow: 1;
        color: #333333;
        background: #fff;
        text-align: right;
        line-height: 45px;

        span {
          color: #FFA941;
        }
      }

      .toRechargeBtn {
        padding: 0 30px;
        display: inline-block;
        line-height: 45px;
        flex-grow: 0;
        color: #fff;
        background: #FFA941;
      }
    }

  }

  .cardSetUp-middle {
    padding: 0 15px 10px;

    .cardSetUp-middle-title {
      font-weight: bold;
      font-size: 18px;
      //line-height: 30px;
      margin-bottom: 10px;
    }

    .package-choose {
      padding: 16px 8px 9px;
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      text-align: center;
    }

    .package-choose-item {
      padding: 0;
      height: 81px;
      flex-basis: 30%;
      margin-bottom: 9px;
      border: 1px solid #C9C9C9;
      border-radius: 8px;

      .package-choose-item-price {
        font-weight: bold;
        height: 52px;
        line-height: 52px;
        font-size: 24px;
        margin: 0;

        span {
          font-size: 14px;
        }
      }

      .packahe-choose-item-desc {
        height: 27px;
        line-height: 27px;
        color: #FB694A;
        font-weight: bold;
        background: #FFE3E1;
        border-radius: 0px 0px 8px 8px;
      }
    }

    .package-item-action-desc {
      background: #FFFFFF !important;
      color: #FB694A !important;
    }

    .package-item-action {
      border: 1px solid #FE9C54 !important;
      color: #fff !important;
      background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%) !important;
    }

    .package-choose-item-defined {
      h1 {
        font-size: 20px;
        line-height: 60px;
      }
    }
  }

  .toRecharge-top {
    display: flex;

    .radio-group-defined {
      display: flex;
      padding-left: 20px;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #eee;
      height: 34px;

      /deep/.van-radio__icon--checked {
        .van-icon-success {
          background-color: #FB694A !important;
          border-color: #FB694A !important;
        }
      }

      /deep/.van-radio__label {
        color: #666;
        margin-left: 0px
      }

      div {
        height: 20px;
        margin-right: 15px;
      }
    }

  }

  .cardSetUp-action-btn {
    padding: 20px 20px 10px 20px;
    color: #fff;

    button {
      width: 100%;
      line-height: 36px;
      font-size: 16px;
      font-weight: bold;
      border-radius: 25px;
      background: #0D7FC6;
      border: none;
    }

  }

  .cardSetUp-tip {
    padding: 10px 20px 10px 20px;

    p {
      span {
        color: #FB684A;
      }

      color: #666666;
      font-size: 13px;
      line-height: 20px;
    }
  }

  .cardSetUp-tip1 {
    padding: 0px 0px 0px 20px;

    p {
      span {
        color: #FFA941;
      }

      line-height: 20px;
    }
  }

  .checkstand-defined {
    .checkstand-defined-popup {
      position: fixed;
      background-color: #fff;
      z-index: 92;
      width: 80%;
      min-height: 30%;
      top: 30%;
      left: 10%;
      border-radius: 15px;

      .input-defined {
        padding: 15px 0 0 30px;
        border-bottom: 1px solid #ccc;
        display: flex;

        span {
          display: inline-block;
          color: #3a3a3a;
          font-size: 16px;
          line-height: 47px;
        }
      }

      .btn-defined {
        padding: 30px 15px 20px 15px;

        button {

          background: rgba(255, 169, 65, 1);
          border: 0px solid rgba(255, 255, 255, 1);
          width: 100%;
          height: 36px;
          color: #fff;
          border-radius: 5px;
        }
      }


    }

    .close-icon {
      position: absolute;
      right: 5px;
      top: -15px;
    }

    h1 {
      margin-top: 5px;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
    }
  }
}


.changePasswordPanel-cardSetUp {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }


}

.shareit {
  -webkit-user-select: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 999;
}

.shareit img {
  max-width: 100%;
}

.arrow {
  width: 100px;
  height: 150px;
  position: absolute;
  right: 5%;
  top: 1%;
}

.follow {
  margin-right: 6px;
  margin-left: 30px;
  width: 90%;
  // height: 100rpx;
  line-height: 30px;
  // text-align: left;
  text-decoration: none;
  font-size: 18px;
  color: white;
  float: left;
  margin-top: 180px;
}
</style>


